import React from 'react'

import { FastTransaction, JointOperation, ReasonablePrice, SecurePayment } from '@enuygun/icons'

export const informationCardDataTR = [
  {
    title: 'En iyi fiyatlar',
    content: 'Yüzlerce firmadan en uygun seçenekleri gör.',
    icon: <ReasonablePrice width={60} height={60} />,
  },
  {
    title: 'Hızlı ve kolay işlem',
    content: 'Rezervasyonunu birkaç tıkla kolayca tamamla.',
    icon: <FastTransaction width={60} height={60} />,
  },
  {
    title: 'Güvenli ödeme',
    content: 'Güvenli ödeme ve taksit seçenekleriyle kolayca öde.',
    icon: <SecurePayment width={60} height={60} />,
  },
  {
    title: 'Tüm seyahatin tek noktada',
    content: 'Uçak, otel, otobüs, araç, transfer hepsi ENUYGUN.com’da!',
    icon: <JointOperation width={60} height={60} />,
  },
]
